import { isInteger, isFunction } from 'lodash';
import {
  differenceInMilliseconds,
  format,
  getUnixTime,
  isValid,
  parseISO,
} from 'date-fns';

import ruLocale from './ruLocale';

export const convertTimeStringToTimeNumber = timeString =>
  Math.round(new Date(timeString).getTime() / 1000);

/**
 * Форматирует дату с нашей локалью
 * @param {string|Date} date YYYY-MM-DD
 * @param {string} formatToken dd MMM
 * @returns {string} 2020-04-25 -> 25 апр
 *
 */

export const isSameDay = (date1, date2) => {
  if (!(date1 instanceof Date) || !(date2 instanceof Date)) return false;

  return date1.getDate() === date2.getDate();
};

export const formatDate = (date, formatToken) => {
  if (!date) return '';
  // Safari не конвертирует дату в формате YYYY-MM-DD, поэтому преобразуем
  // Регулярное выражение для проверки формата 'YYYY-MM-DD HH:MM:SS +/-HHMM'
  const regexStringDate = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(?: \+\d{4})?$/;
  if (typeof date === 'string' && regexStringDate.test(date)) {
    return format(new Date(date.replace(/-/g, '/')), formatToken, {
      locale: ruLocale,
    });
  }
  return format(new Date(date), formatToken, {
    locale: ruLocale,
  });
};

/**
 * Форматирует дату полностью, например 23 сентября 2018
 * @param date YYYY-MM-DD
 * @returns {string}
 * @deprecated используй formatDate
 */
export const formatDateToDayFull = date => formatDate(date, 'd MMMM yyyy');

export function isToday(someDate) {
  const today = new Date();
  return (
    someDate.getDate() === today.getDate() &&
    someDate.getMonth() === today.getMonth() &&
    someDate.getFullYear() === today.getFullYear()
  );
}

/**
 * Возвращает время для таймера в unixtime
 * @param {object} props
 * @param {number?} props.seconds
 * @returns {string} unix
 */
export const getDurationTime = ({ seconds = 0, minutes = 0 }) => {
  const duration = new Date().setHours(0, minutes, seconds, 0);
  return duration;
};

/**
 * Возвращает разницу между двумя unix timestamp
 * @param {string} answeredAt
 * @param {string} finishedAt
 * @returns {number}
 */
export const getCallDuration = (answeredAt, finishedAt) => {
  if (!isInteger(answeredAt)) {
    return -1;
  }

  const current = new Date();

  // @ts-ignore
  const now = isFunction(Date.getServerTime)
    ? // @ts-ignore
      Date.getServerTime() // Syncer of CRM server time
    : getUnixTime(current);

  const finishedAtOrNow = finishedAt || now;

  const seconds = finishedAtOrNow - answeredAt;
  return seconds;
};

export const parseISODate = (dateISO?: string): string => {
  if (!dateISO) {
    return '';
  }

  const parsed = parseISO(dateISO);

  if (isValid(parsed)) {
    return formatDate(parsed, 'dd MMM yyyy');
  }

  return '';
};

/**
 * Возвращается строка с диапазоном дат и количество ночей
 * @param {string} startDate
 * @param {string} endDate
 * @param {number} nights
 * @returns {string}
 */

export const getDateRange = (
  startDate: string,
  endDate: string | Date,
  nights: number
): string => `${startDate} - ${endDate}, ${nights}`;

/**
 * Переводит миллисекунды в дни, часы и минуты
 * @param {number} milliseconds
 * @returns {string} "5д 10ч 33м"
 */
export const formatMilliseconds = (milliseconds: number) => {
  const minutes = Math.floor(milliseconds / (1000 * 60)) % 60;
  const hours = Math.floor(milliseconds / (1000 * 60 * 60)) % 24;
  const days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));

  return minutes || hours || days
    ? [
        days ? `${days}д` : '',
        hours ? `${hours}ч` : '',
        minutes ? `${minutes}м` : '',
      ]
        .filter(Boolean)
        .join(' ')
    : '0м';
};

export const isNight = date => {
  if (!(date instanceof Date)) return false;

  const startDayHour = 8;
  const endDayHour = 20;
  const dateHour = date.getHours();

  return dateHour >= startDayHour && dateHour <= endDayHour;
};
